import React, { useEffect, useState } from "react";
import AppointmentsService from "../../appointments/appointmentService";
import DiagnosisCombinerService from "../../Authorization/diagnosisCombinerService";
import RatingService from "../../Rating/RatingService";

const appointmentService = new AppointmentsService();
const diagnosisCombinerService = new DiagnosisCombinerService();

const PatientRatings = ({ authorizations }) => {
  const [ratings, setRatings] = useState([]);
  const role = localStorage.getItem("role");

  useEffect(() => {
    const fetchRatings = async () => {
      if (role !== "PATIENT") return;

      const seen = new Set();
      const results = [];

      for (const auth of authorizations) {
        try {
          const diagnosisList = await diagnosisCombinerService.getByAuthId(auth.authId);
          if (diagnosisList && diagnosisList.length > 0) {
            const diagCombId = diagnosisList[0].diagCombId;
            const appointments = await appointmentService.getAppointmentsByDiagComb(diagCombId);

            for (const appt of appointments) {
              const apptId = appt.appoinmentId;
              if (!seen.has(apptId)) {
                seen.add(apptId);
                try {
                  const rating = await RatingService.getRatingByAppointmentId(apptId);
                  if (rating) {
                    results.push({
                      appointmentId: apptId,
                      appointmentDate: appt.appointmentDate,
                      rating: rating.rating,
                      officeRating: rating.officeRating,
                      anonymous: rating.anoymonous,
                    });
                  }
                } catch (err) {
                  // No rating found — skip
                }
              }
            }
          }
        } catch (err) {
          console.error("Error fetching ratings:", err);
        }
      }

      setRatings(results);
    };

    if (authorizations?.length > 0) {
      fetchRatings();
    }
  }, [authorizations, role]);

  const openEditRating = (appointmentId) => {
    sessionStorage.setItem("appointmentId", appointmentId);
    window.open("/ratingPopup", "_blank", "width=600,height=600");
  };

  // ⛔ Only render if patient
  if (role !== "PATIENT") return null;

  return (
    <div
      className="info-box"
      style={{
        maxHeight: "400px",
        overflowY: "auto",
        backgroundColor: "white",
        borderRadius: "10px",
        padding: "20px",
        boxShadow: "0 0 10px rgba(0,0,0,0.1)",
      }}
    >
      <h3 style={{ marginBottom: "10px" }}>Ratings</h3>
      {ratings.length > 0 ? (
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              <th>Date</th>
              <th>Rating</th>
              <th>Office</th>
              <th>Anon</th>
              <th>Edit</th>
            </tr>
          </thead>
          <tbody>
            {ratings.map((r, idx) => (
              <tr key={idx}>
                <td>{r.appointmentDate}</td>
                <td>{r.rating || "-"}</td>
                <td>{r.officeRating || "-"}</td>
                <td>{r.anonymous ? "Yes" : "No"}</td>
                <td>
                  <button onClick={() => openEditRating(r.appointmentId)}>✏️</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p><i>No ratings found.</i></p>
      )}
    </div>
  );
};

export default PatientRatings;
